import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TUserApi } from './types';

export const user: TUserApi = {
	getOrganizations: () =>
		http
			.get(`https://emd1.easproject.com${endpoint.user.ORGANIZATIONS}`)
			.then(response => response.data),
	getUserInfo: () => http.get(endpoint.user.USER_INFO).then(response => response.data),
	getNewMessageCount: () =>
		http.get(endpoint.user.GET_NEW_MESSAGE_COUNT).then(response => response.data),
	getMessages: () => http.get(endpoint.user.FETCH_MESSAGES).then(response => response.data),
	getUsersList: () => http.get(endpoint.user.ALL_USERS).then(response => response.data),
	saveSessionData: data =>
		http.post(endpoint.user.SAVE_SESSION_DATA, data).then(response => response.data),
};
